(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  document.querySelectorAll('.js-mob-drawer-close').forEach((btn) => {
    btn.addEventListener('click', () => {
      const disclosure = btn.closest('details');
      if (disclosure) disclosure.querySelector(':scope > summary').click();
    });
  });

  (function initGrandchildPanels() {
    const isMobile = () => !window.matchMedia(theme.mediaQueries.md).matches;

    function openPanel(panel, details) {
      panel.origParent = panel.parentNode;
      panel.style.removeProperty('height');
      document.body.appendChild(panel);
      details.open = true;

      requestAnimationFrame(() => requestAnimationFrame(() => {
        panel.classList.add('mob-grandchild-panel--open');
      }));
    }

    function closePanel(panel) {
      panel.classList.remove('mob-grandchild-panel--open');
      setTimeout(() => {
        if (panel.origParent) panel.origParent.appendChild(panel);
        if (panel.origDetails) panel.origDetails.open = false;
        panel.style.removeProperty('height');
      }, 220);
    }

    function cleanupNow() {
      const panel = document.querySelector('.mob-grandchild-panel--open');
      if (!panel) return;
      panel.classList.remove('mob-grandchild-panel--open');
      if (panel.origParent) panel.origParent.appendChild(panel);
      if (panel.origDetails) panel.origDetails.open = false;
      panel.style.removeProperty('height');
    }

    document.querySelectorAll('.main-nav__child nav-menu').forEach((navMenu) => {
      const summary = navMenu.querySelector('summary');
      const details = navMenu.querySelector('details');
      const panel = navMenu.querySelector('.disclosure__panel');
      if (!summary || !details || !panel) return;

      panel.origDetails = details;

      // Capture phase — fires before DetailsDisclosure's bubble listener
      summary.addEventListener('click', (e) => {
        if (!isMobile()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        if (!details.open) openPanel(panel, details);
      }, true);
    });

    // Back button
    document.addEventListener('click', (e) => {
      if (!isMobile()) return;
      if (!e.target.closest('.js-grandchild-back')) return;
      e.preventDefault();
      const panel = document.querySelector('.mob-grandchild-panel--open');
      if (panel) closePanel(panel);
    });

    // Cleanup when main menu closes (any trigger — hamburger, X, swipe, etc.)
    const mainDisclosure = document.querySelector('.main-menu__disclosure');
    if (mainDisclosure) {
      new MutationObserver(() => {
        if (!mainDisclosure.open) cleanupNow();
      }).observe(mainDisclosure, { attributes: true, attributeFilter: ['open'] });
    }

    // Cleanup on resize to desktop
    window.addEventListener('on:breakpoint-change', () => {
      if (window.matchMedia(theme.mediaQueries.md).matches) cleanupNow();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
